import _defineProperty from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import Uleague from '@/config/hosts/uleague';
import Changyou from '@/config/hosts/changyou';
import Ccsu from '@/config/hosts/ccsu';
import Metacity from '@/config/hosts/metacity';
import Deng from '@/config/hosts/deng';
import Hnxbzzk from '@/config/hosts/hnxbzzk';
import Yinhe from '@/config/hosts/yinhe';
import Zgny from '@/config/hosts/zgny';
import Ipbank from '@/config/hosts/ipbank';
import Tjnfr from '@/config/hosts/tjnfr';
import TestX from '@/config/hosts/testx';

var alternateHosts = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, Uleague), Changyou), Ccsu), Metacity), Zgny), Deng), Hnxbzzk), Yinhe), Ipbank), Tjnfr), TestX); // 生成备用域名


var transformAlternateHosts = Object.keys(alternateHosts).map(function (x) {
  return Array.from({
    length: 6
  }, function (y, i) {
    var splits = x.split('.');
    var domain = splits.shift() || '';
    var newDomain = i ? "".concat(domain + i) : domain;
    splits.unshift(newDomain);
    return _defineProperty({}, splits.join('.'), alternateHosts[x]);
  });
}).flat(2);
var generatorAlternateHosts = transformAlternateHosts.reduce(function (prev, next) {
  return _objectSpread(_objectSpread({}, prev), next);
}, {});
export default generatorAlternateHosts;